export enum FeatureTypes {
  ACCOUNT = 'feature-account',
  LEGACY_APPLICATION = 'legacy-application',
  IMMEDIATE_DELIVERY_PERMISSION = 'immediate-delivery-permission',
  RENEWAL_TOP = 'renewal-top'
}

export const isFeatureEnable = (feature: FeatureTypes): boolean => {
  const searchParams = new URLSearchParams(location.search);
  return searchParams.get(feature) === 'true';
};
